module.exports = __webpack_public_path__ + "static/media/icon-close.1e9f59ea.png";